import { render, staticRenderFns } from "./PhoneCodesDropDown.vue?vue&type=template&id=d4127478&scoped=true&"
import script from "./PhoneCodesDropDown.vue?vue&type=script&lang=js&"
export * from "./PhoneCodesDropDown.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCodesDropDown.vue?vue&type=style&index=0&id=d4127478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4127478",
  null
  
)

export default component.exports